import { createContext, ReactNode, useContext } from "react";
import { useSelector } from "react-redux";
import { Theme } from "@/GlobalSlice/theme.type";
import { RootState } from "@/app/store";

interface ThemeContextValue {
  theme: Theme;
}

interface ThemeProviderProps {
  children: ReactNode;
}

const defaultTheme: Theme = {
  primaryColor: "#1976d2",
  secondaryColor: "#DCC6E7",
  tertiaryColor: "#fff",
  buttonsColor: "#292929",
  textColor: "#fff",
  fontFamily: "Manrope",
  lightColor: "#4b1849ad",
};

const ThemeContext = createContext<ThemeContextValue>({
  theme: defaultTheme,
});

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const theme = useSelector((state: RootState) => state.theme.theme);

  return (
    <ThemeContext.Provider value={{ theme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
